import CurrentLocationComponent from '../CurrentLocation';
import { Body } from '../Typography';
import { fontWeight } from '../../theme/typography';
import { LocationSelectError } from '../location-select-error/LocationSelectError';
import { palette } from '../../theme/palette';
import { styled, Typography } from '@mui/material';

export const ClearLabel = styled(Typography)`
  color: ${palette.primary.main};
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.35px;
  white-space: nowrap;
`;

export const CurrentLocation = styled(CurrentLocationComponent, {
  shouldForwardProp: (prop) => prop !== 'hasTopMargin',
})<{
  hasTopMargin?: boolean;
}>`
  width: 100%;
  border-radius: 5px;
  border: 1px solid;
  background: white;
  height: 40px;
  margin-top: ${(props) => (props.hasTopMargin ? '14px' : '0px')};
`;

export const StyledLocationSelectError = styled(LocationSelectError)`
  margin-bottom: 14px;
`;

export const NoLocationText = styled(Body)`
  margin: 0 0 0 2px;
  padding: 2px 10px 2px 0px;
  font-size: 14px;
  font-weight: ${fontWeight.regular};
  line-height: 28px;
  letter-spacing: 0.35px;
`;

export const InvalidAddressText = styled(NoLocationText)`
  cursor: pointer;
`;

export const HelperText = styled(Typography)`
  padding-top: 15px;
  padding-left: 16px;
  display: flex;
  font-size: 12px;
  flex-direction: row;
  align-items: center;
  gap: 11px;
  cursor: pointer;
`;
